import { render, staticRenderFns } from "./InstallTeacher.vue?vue&type=template&id=73994f2e&scoped=true&"
import script from "./InstallTeacher.vue?vue&type=script&lang=ts&"
export * from "./InstallTeacher.vue?vue&type=script&lang=ts&"
import style0 from "./InstallTeacher.vue?vue&type=style&index=0&id=73994f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73994f2e",
  null
  
)

component.options.__file = "InstallTeacher.vue"
export default component.exports